import React from "react";

import styles from "./table.module.scss";

export const NoRecords = ({ title = "No Records to Display" }) => (
	<div className={styles.noRecords}>{title}</div>
);
